import "core-js/modules/es6.function.name";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  name: 'timelineChart',
  props: ['chart'],
  methods: {
    initTimeLineChart: function initTimeLineChart(chartData) {
      var years = ['COD', 'PH', 'TP', 'TN', 'SS'];
      var option = {
        baseOption: {
          timeline: {
            data: years,
            axisType: 'category',
            autoPlay: true,
            playInterval: 10000,
            left: '10%',
            right: '10%',
            bottom: '0%',
            width: '80%',
            label: {
              normal: {
                textStyle: {
                  color: '#ff8800'
                }
              },
              emphasis: {
                textStyle: {
                  color: '#fff'
                }
              }
            },
            symbolSize: 10,
            lineStyle: {
              color: '#555'
            },
            checkpointStyle: {
              borderColor: '#777',
              borderWidth: 2
            },
            controlStyle: {
              showNextBtn: true,
              showPrevBtn: true,
              normal: {
                color: '#ff8800',
                borderColor: '#ff8800'
              },
              emphasis: {
                color: '#aaa',
                borderColor: '#aaa'
              }
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['进水', '出水'],
            textStyle: {
              color: '#fff'
            },
            axisLabel: {
              color: '#fff' //刻度线标签颜色

            }
          },
          calculable: true,
          grid: {
            left: '8%',
            right: '8%',
            bottom: '18%',
            top: '10%',
            containLabel: true
          },
          label: {
            normal: {
              textStyle: {
                color: '#fff'
              }
            }
          },
          yAxis: [{
            offset: '37',
            type: 'category',
            data: '',
            nameTextStyle: {
              color: '#fff'
            },
            axisLabel: {
              //rotate:45,
              textStyle: {
                fontSize: 12,
                color: '#333'
              },
              interval: 0
            },
            axisLine: {
              lineStyle: {
                color: '#333'
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#333'
              }
            }
          }],
          xAxis: [{
            type: 'value',
            name: '',
            splitNumber: 8,
            nameTextStyle: {
              color: '#333'
            },
            axisLine: {
              lineStyle: {
                color: '#333'
              }
            },
            axisLabel: {
              formatter: '{value} '
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#ccc'
              }
            }
          }],
          series: [{
            name: '',
            type: 'bar',
            markLine: {
              label: {
                normal: {
                  show: false
                }
              },
              lineStyle: {
                normal: {
                  color: 'red',
                  width: 3
                }
              }
            },
            barWidth: '50%',
            label: {
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}'
              }
            },
            itemStyle: {
              normal: {
                color: function color(params) {
                  // build a color map as your need.
                  var colorList = ['#bcd3bb', '#e88f70', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a', '#376956', '#c3bed4', '#495a80', '#9966cc', '#bdb76a', '#eee8ab', '#a35015', '#04dd98', '#d9b3e6', '#b6c3fc', '#315dbc'];
                  return colorList[params.dataIndex];
                }
              }
            }
          }],
          animationDurationUpdate: 2000,
          animationEasingUpdate: 'quinticInOut'
        },
        options: []
      };

      for (var n = 0; n < years.length; n++) {
        var res = [];
        var resTwo = [];

        for (var j = 0; j < chartData.data[n].length; j++) {
          res.push({
            name: chartData.jdData[n][j],
            value: chartData.data[n][j]
          });
          resTwo.push({
            name: chartData.jdData[n][j],
            value: chartData.data2[n][j]
          });
        }

        var res1 = [];
        var res2 = [];
        var resTwo1 = [];
        var resTwo2 = [];

        for (var t = 0; t < res.length; t++) {
          res1[t] = res[t].name;
          res2[t] = res[t].value;
          resTwo1[t] = resTwo[t].name;
          resTwo2[t] = resTwo[t].value;
        }

        option.options.push({
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: res1,
            axisLabel: {
              color: '#fff' //刻度线标签颜色

            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              color: '#fff' //刻度线标签颜色

            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
          },
          series: [{
            name: '进水',
            type: 'line',
            data: res2
          }, {
            name: '出水',
            type: 'line',
            data: resTwo2
          }]
        });
      }

      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option, true);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};